import { memo } from 'react';
import type { CheckListFilterProps } from '.';
import { CheckListFilterWithApi } from './check-list-filter-with-api';
import { CheckListFilterWithOptions } from './check-list-filter-with-options';

export const CheckListFilter = memo((props: CheckListFilterProps) => {
  const isDataComeFromMetadataApi = props.metadata?.metaDataApi?.enabled;

  return isDataComeFromMetadataApi ? (
    <CheckListFilterWithApi {...props} />
  ) : (
    <CheckListFilterWithOptions {...props} />
  );
});

CheckListFilter.displayName = 'CheckListFilter';
